function formatHighlightValue(extra = {}) {
  const value = extra.value ?? "";
  const suffix = extra.suffix ?? "";
  return `${value}${suffix}`.trim();
}

export default function AboutSection({ section, highlights = [] }) {
  if (!section || section.is_enabled === 0) return null;

  const visionTitle = section.extra?.vision_title || "Vision";
  const visionText = section.extra?.vision_text || "";
  const missionTitle = section.extra?.mission_title || "Mission";
  const missionText = section.extra?.mission_text || "";

  return (
    <section className="section about-home" id="about" aria-label="About Mokorotlo College">
      <div className="section__inner">
        <div className="section__header">
          <span className="section__tag">About Us</span>
          <h2 className="section__title">{section.title}</h2>
          {section.subtitle && <p className="section__subtitle">{section.subtitle}</p>}
        </div>

        <div className="about-home__layout">
          <div className="about-home__content">
            {section.badge && <div className="about-home__badge">{section.badge}</div>}
            {section.body && <p className="about-home__text">{section.body}</p>}
            {section.secondary_body && <p className="about-home__text">{section.secondary_body}</p>}
          </div>

          {section.image_url && (
            <div className="about-home__image-card">
              <img src={section.image_url} alt={section.title} className="about-home__image" loading="lazy" />
            </div>
          )}
        </div>

        <div className="about-home__vision-mission">
          {section.secondary_image_url && (
            <div className="about-home__vision-mission-image">
              <img src={section.secondary_image_url} alt={`${section.title} secondary`} className="about-home__image" loading="lazy" />
            </div>
          )}
          <div className="about-home__vision-mission-content">
            <div className="about-home__panel">
              <h3>{visionTitle}</h3>
              <p>{visionText}</p>
            </div>
            <div className="about-home__panel">
              <h3>{missionTitle}</h3>
              <p>{missionText}</p>
            </div>
          </div>
        </div>

        {highlights.length > 0 && (
          <div className="about-home__highlights">
            {highlights.map((item) => (
              <article key={item.id} className="about-highlight-card">
                {formatHighlightValue(item.extra) && (
                  <div className="about-highlight-card__value">{formatHighlightValue(item.extra)}</div>
                )}
                <h3>{item.title}</h3>
                {item.subtitle && <p className="about-highlight-card__eyebrow">{item.subtitle}</p>}
                {item.body && <p className="about-highlight-card__text">{item.body}</p>}
              </article>
            ))}
          </div>
        )}
      </div>
    </section>
  );
}
